import React, { useEffect } from "react";
import "./search-bar.m.css";
import { SearchBox } from "@quintype/components";
import Search from "../../atoms/other-icons/Search";

function SearchBar({ defaultValue }) {
  const SearchIconTemplate = ({ children }) => (
    <div styleName="search-wrapper">
      {children}
      <button type="submit" styleName="search search-btn">
        <Search color="black" height="16px" width="16px" />
      </button>
    </div>
  );

  useEffect(() => {
    window.onload = function () {
      document.querySelector("input").focus();
    };
  }, []);

  return (
    <SearchBox
      placeholder="Search here…"
      inputId="searchForm"
      inputClassName="search__form-input"
      template={SearchIconTemplate}
      initValue={defaultValue}
    />
  );
}

export default SearchBar;
